/**
 * Pins a request to the org it was made for. Switching org does not reload
 * the page, so the API refuses a read or write the session's token now
 * answers for another org.
 */
export const expectedOrganizationHeaders = (organizationId: string) => ({
  'X-Cleanlist-Expected-Org': organizationId,
});
